/**
 * @file PhoneGridField.tsx
 * @description «На телефоне» у сеток элементов секции схемами (phase19.16,
 * партия SB120, этап 3б; uiux-sb120-stage3 §3, §8 «Создаём»): [▤ стопкой]
 * [▦ по две][⇆ лентой] — набор и подписи shared (`PHONE_GRID_LAYOUTS`,
 * `PHONE_GRID_LAYOUT_LABELS`), одни на все панели (плитки, категории,
 * товары, галерея, объявления-карточки, статьи, похожие товары).
 * Необязательное поле (статьи) показывает умолчание вида, пока ключа нет.
 */

import { PHONE_GRID_LAYOUT_LABELS, PHONE_GRID_LAYOUTS, type PhoneGridLayout } from "@chaiberi/shared";

import { Label } from "../../../ui/label";
import { OptionCards } from "../../../site-view/OptionCards";

/** Мини-схема раскладки: три карточки стопкой, по две или лентой с краем следующей. */
function PhoneScheme({ layout }: { layout: PhoneGridLayout }) {
  const cell = "rounded-sm bg-primary/40";
  if (layout === "stack") {
    return (
      <span aria-hidden className="mx-auto flex w-8 flex-col gap-0.5">
        {[0, 1, 2].map((i) => (
          <span key={i} className={`${cell} h-3`} />
        ))}
      </span>
    );
  }
  if (layout === "grid2") {
    return (
      <span aria-hidden className="mx-auto grid w-8 grid-cols-2 gap-0.5">
        {[0, 1, 2, 3].map((i) => (
          <span key={i} className={`${cell} h-4`} />
        ))}
      </span>
    );
  }
  return (
    <span aria-hidden className="mx-auto flex w-10 gap-0.5 overflow-hidden">
      <span className={`${cell} h-9 w-6 shrink-0`} />
      <span className={`${cell} h-9 w-6 shrink-0 opacity-60`} />
    </span>
  );
}

const OPTIONS = PHONE_GRID_LAYOUTS.map((value) => ({ value, label: PHONE_GRID_LAYOUT_LABELS[value], preview: <PhoneScheme layout={value} /> }));

interface Props {
  value: PhoneGridLayout;
  onChange: (value: PhoneGridLayout) => void;
  /** «Плитки на телефоне» — имя группы для скринридера. */
  ariaLabel: string;
}

export function PhoneGridField({ value, onChange, ariaLabel }: Props) {
  return (
    <div className="flex min-w-0 flex-col gap-1">
      <Label>На телефоне</Label>
      <OptionCards aria-label={ariaLabel} columns={3} options={OPTIONS} value={value} onChange={onChange} />
    </div>
  );
}
